import React, { type Ref, type JSX } from "react";

import AccessibleButton, { type ButtonProps } from "../../components/views/elements/AccessibleButton";

type Props<T extends keyof HTMLElementTagNameMap> = ButtonProps<T> & {
    label?: string;
    // whether the context menu is currently open
    isExpanded: boolean;
    ref?: Ref<HTMLElementTagNameMap[T]>;
};

// Semantic component for representing the AccessibleButton which launches a <ContextMenu />
export const ContextMenuButton = function <T extends keyof HTMLElementTagNameMap>({
    label,
    isExpanded,
    children,
    onClick,
    onContextMenu,
    ref,
    ...props
}: Props<T>): JSX.Element {
    return (
        <AccessibleButton
            {...props}
            onClick={onClick}
            onContextMenu={onContextMenu ?? onClick ?? undefined}
            aria-label={label}
            aria-haspopup={true}
            aria-expanded={isExpanded}
            ref={ref}
        >
            {children}
        </AccessibleButton>
    );
};
